<template>
    <v-flex>
        <v-combobox
            v-if="isEditable"
            ref="combobox"
            key="enable"
            v-model="chips"
            :clearable="!isDisabled"
            :hint="existsMaxCount ? $t('Maximum_of_count_tags', { count: maxCountWithCommas }) : ''"
            :placeholder="placeholderName"
            :disabled="isDisabled"
            :rules="[chipsMaxChars]"
            class="text-body-2 ma-0 pa-0"
            chips
            append-icon
            multiple
        >
            <template v-slot:selection="{ selected, item }">
                <v-chip
                    :input-value="selected"
                    :close="!isDisabled"
                    :disabled="disabled"
                    @click:close="removeChip(item)"
                >
                    <label class="chip-label text-caption"> {{ item }} </label>
                </v-chip>
            </template>
            <template v-if="isShowIcon" v-slot:append>
                <v-icon :disabled="isDisabled"> edit </v-icon>
            </template>
        </v-combobox>
        <v-flex v-else key="disable" class="label-for-input-form text-caption">
            <v-chip v-for="(name, index) in chips" :key="index" disabled>
                <span class="chip-text text-caption"> {{ name }} </span>
            </v-chip>
        </v-flex>
    </v-flex>
</template>

<script lang="ts">
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import InputValidation from '../../../mixins/InputValidation';
import { numberWithCommas } from '../../../utils/types/numberWithCommas';

@Component({
    name: 'SimpleChipsInputter',
})
export default class SimpleChipsInputter extends mixins(InputValidation) {
    @Prop({ default: [] }) initValue: Array<string>;
    @Prop({ default: true }) editable: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: '' }) placeholder: string;
    @Prop({ default: -1 }) maxCount: number;
    @Prop({ default: false }) isShowAppendIcon: boolean;
    @Watch('initValue', { deep: true, immediate: true })
    onInitValueChanged(val: Array<string>, oldVal: Array<string>): void {
        this.chips = val;
    }
    @Watch('chips.length')
    onChipsLengthChanged(val: number, oldVal: number): void {
        if (this.existsMaxCount && val > this.maxCount) {
            this.$nextTick(() => this.chips.pop());
        }
        this.$emit('input', this.chips);
    }

    chips: Array<string> = [];

    /**
     * getter
     */
    get isEditable(): boolean {
        return this.editable;
    }
    get isDisabled(): boolean {
        return this.disabled;
    }
    get existsMaxCount(): boolean {
        return this.maxCount !== -1;
    }
    get maxCountWithCommas(): string {
        return numberWithCommas(this.maxCount);
    }
    get placeholderName(): string {
        return this.placeholder;
    }
    get isShowIcon(): boolean {
        return this.isDisabled ? this.isShowAppendIcon : this.chips.length < 1 && this.isShowAppendIcon;
    }

    /**
     * methods
     */
    removeChip(item: string) {
        this.chips.splice(this.chips.indexOf(item), 1);
        this.chips = [...this.chips];
    }
    chipsMaxChars(): boolean | string {
        let result: boolean | string = true;
        this.chips.some(chip => {
            result = (this.rules as any).maxChars(chip, 64);
            return result !== true;
        });

        return result;
    }
    blur() {
        (this as any).$refs['combobox'].blur();
    }
}
</script>

<style lang="scss" scoped>
.chip-label {
    max-width: 15rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.chip-text {
    color: rgba(0, 0, 0, 0.87);
}
</style>
